import { render } from "./appoint-coordinator.html?vue&type=template&id=12d430cc&scoped=true&ts=true&external"
import script from "./appoint-coordinator.ts?vue&type=script&lang=ts&external"
export * from "./appoint-coordinator.ts?vue&type=script&lang=ts&external"

import "./appoint-coordinator.scss?vue&type=style&index=0&id=12d430cc&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d430cc"]])

export default __exports__